import LoadingEndState from '../../store/schema/LoadingEndState';
import LogNames from 'txp-data/lib/schema/telemetry/LogNames';
import TxpEntitiesState from 'txp-data/lib/schema/innerSchema/TxpEntitiesState';
import TxpStatus from 'txp-data/lib/schema/TxpStatus';

/**
 * populate the loading state dataPoint object
 */

export default function populateLoadingDataPoint(
    entityNamesMap: number,
    loadingEndState: LoadingEndState,
    txpStatus: TxpStatus,
    isTxpObjectValid: boolean
) {
    let state = null;
    let isEmailDonationRequested = null;
    if (txpStatus) {
        state = txpStatus.state;
        isEmailDonationRequested = txpStatus.isEmailDonationRequested;
    }
    return {
        [LogNames.entityNamesMap]: entityNamesMap ? entityNamesMap.toString() : null,
        [LogNames.endState]:
            loadingEndState !== null && loadingEndState !== undefined
                ? LoadingEndState[loadingEndState]
                : null,
        [LogNames.tailoredEntityState]:
            state !== null && state !== undefined ? TxpEntitiesState[state] : null,
        [LogNames.teeEmailDonationRequested]:
            typeof isEmailDonationRequested == typeof true
                ? isEmailDonationRequested.toString()
                : null,
        [LogNames.isTxpObjectValid]:
            typeof isTxpObjectValid == typeof true ? isTxpObjectValid.toString() : null,
    };
}
